/*** IMPORTS FROM imports-loader ***/
var define = false;

export function getAppBreakpoints() {
  return {
    small: 0,
    medium: '768px',
    large: '1024px',
    xlarge: '1440px',
    xxlarge: '1920px',
    xxxlarge: '3840px',
    w1280: '1280px',
    w1366: '1366px',
    w1440: '1440px',
  }
}

